import { auth } from '@/firebase';
const URL = 'https://faas-nyc1-2ef2e6cc.doserverless.co/api/v1/web/fn-12f47b02-5e16-417c-b4e1-1566a1d5fe44/v1/entities';

class Entities {
    static async post(path='', body, token=null) {
        const response = await fetch(`${URL}${path}`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token || await auth.currentUser.getIdToken()}`,
                'Content-Type': 'multipart/form-data',
            },
            body: body,
        });

        return response.json();
    }
}

export default Entities;